/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/heading-2
 */
import { default as DefaultIcon } from '~icons/lucide/heading-2';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const Heading2Icon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
